import React, { useEffect, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Tooltip, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import GoogleIcon from '@mui/icons-material/Google';
import GroupIcon from '@mui/icons-material/Group';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WindowIcon from '@mui/icons-material/Window';
import api from '../../../api';
import useNotification from '../../Notification';
import VerAgendas from '../VerAgendas/ver_agendas';
import Notifications from '../Notifications';
import userPermissions from '../../User/Permissions';
import {distributedCalendar} from '../DistributedCalendar';

const groups = userPermissions()

const fakePopup = {
  close: () => {}
}

let timeout = 0
let popup = null

const openCalendarConnect = async ({provider, scopes, redirect_url, callback}) => {
    (popup || fakePopup).close()
    const res = await api.get("/api/oauth/embedding/?" +
            new URLSearchParams({
                provider: provider,
                scopes: scopes,
                redirect_url: redirect_url,
            }))

    popup = window.open(
        res.data,
        "_blank",
        "width=500,height=750,noopener=false"
    )

    let stopped = false

    const poll = async () => {
        if (stopped)
            return
        try {
            const res = await api.get("/api/oauth/check_status/")
            if (res.data.status === "SUCCESS") {
                stopped = true
                // TODO: sync google calendar
                useNotification(
                    "Sucesso",
                    "Agenda conectada com sucesso.",
                    "success"
                )
                await callback()
                return
            }
            if (popup?.closed)
              return
        } catch (e) {}
        clearTimeout(timeout)
        timeout = setTimeout(poll, 2000)
    }
    poll()
}

export const ConfigAgenda = ({ originNumbers, calendarNotification, setCalendarNotification }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [verAgendas, setVerAgendas] = useState(false)
  const [notifications, setNotifications] = useState(false)
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {verAgendas && <VerAgendas handleClose={()=>setVerAgendas(false)}/>}
      {notifications &&
        <Notifications
          handleClose={() => setNotifications(false)}
          originNumbers={originNumbers}
          calendarNotification={calendarNotification}
          setCalendarNotification={setCalendarNotification}
        />
      }
      <Tooltip title='Configurar agendas'>
            <IconButton 
              id="config-agenda-menu-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
                <SettingsIcon />
            </IconButton>
        </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'config-agenda-menu-button',
          },
        }}
      >
        <MenuItem onClick={()=>openCalendarConnect(
          {
                provider: "MICROSOFT_CALENDAR",
                scopes: "offline_access Calendars.ReadWrite openid profile email",
                redirect_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
                callback: () => {distributedCalendar.clear_promise(); distributedCalendar.reload_calendar()}
            }
        )}>
          <ListItemIcon>
            <WindowIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            Conectar Agenda Microsoft
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={()=>openCalendarConnect(
          {
            provider: "GOOGLE_CALENDAR",
            scopes: "openid email https://www.googleapis.com/auth/calendar",
            redirect_url: "https://accounts.google.com/o/oauth2/v2/auth",
            callback: () => {distributedCalendar.clear_promise(); distributedCalendar.reload_calendar()}
          }
        )}>
           <ListItemIcon>
            <GoogleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            Conectar Agenda Google
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={()=> setVerAgendas(true)}>
           <ListItemIcon>
            <GroupIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            Agendas Conectadas
          </ListItemText>
        </MenuItem>
        {groups.isAdmin && 
          <MenuItem onClick={()=> setNotifications(true)}>
             <ListItemIcon>
              <NotificationsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              Configurar Notificações
            </ListItemText>
          </MenuItem>
        }
      </Menu>
    </div>
  );
}

export default ConfigAgenda
